module.exports = __webpack_public_path__ + "static/media/comprar.9643c505.svg";